<template>
  <table class="table-hover reports-table time-off-balances-report-table table">
    <TimeOffBalancesReportTableHeader />

    <tbody>
      <tr>
        <td
          class="time-off-balances-outer"
          colspan="100%"
        >
          <VirtualList
            page-mode
            data-key="uuid"
            :data-component="sectionComponent"
            :data-sources="tableData.sections"
            :extra-props="sectionExtraProps"
            :keeps="30"
            :estimate-size="55"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { markRaw } from 'vue';
import { mapGetters } from 'vuex';
import VirtualList from 'vue3-virtual-scroll-list';
import TimeOffBalancesReportTableHeader from './TimeOffBalancesReportTableHeader.vue';
import TimeOffBalancesReportSection from './TimeOffBalancesReportSection.vue';

export default {
  name: 'TimeOffBalancesReportTable',
  components: { VirtualList, TimeOffBalancesReportTableHeader },
  props: {
    tableData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['walker', 'tableIsTeam', 'allMembers']),
    baseColCount() {
      return this.walker.base_column_count;
    },
    colCount() {
      if (this.tableIsTeam) {
        return this.baseColCount + 1;
      }

      return this.baseColCount;
    },
    sectionComponent() {
      return markRaw(TimeOffBalancesReportSection);
    },
    sectionExtraProps() {
      return {
        baseColCount: this.baseColCount,
        colCount: this.colCount,
        subShow: this.walker.sub_show,
        allMembers: this.allMembers,
      };
    },
  },
};
</script>
